import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';

type MutationInput = {
  clientId: string;
  dataUploadFileId: string;
  documentDate: Date;
  isResolved: boolean;
  parentId: string | undefined;
};

export function useUpdateFileDocumentDate() {
  const queryClient = useQueryClient();

  const {
    mutateAsync,
    error,
    isPending: isLoading,
    reset,
  } = useMutation<unknown, Error, MutationInput>({
    mutationFn: ({
      clientId,
      dataUploadFileId,
      documentDate,
      isResolved,
      parentId,
    }: MutationInput) =>
      api.put(`clients/${clientId}/data-upload-files/${dataUploadFileId}`, {
        documentDate: documentDate.toISOString().split('T')[0],
        isResolved,
        parentId: parentId ?? null,
        isFiled: false,
      }),
    onSettled: (_data, _error, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['clients', variables.clientId, 'data-upload-files'],
      });
    },
  });

  const updateDocumentDate = async (
    clientId: string,
    dataUploadFileId: string,
    documentDate: Date,
    isResolved: boolean,
    parentId: string | undefined,
  ) => {
    return mutateAsync({ clientId, dataUploadFileId, documentDate, isResolved, parentId });
  };

  return {
    updateDocumentDate,
    error,
    isLoading,
    reset,
  };
}
